module.exports = __webpack_public_path__ + "img/3-4.90d5ab2d.png";